import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ClockIcon from 'Components/icons/ClockIcon/ClockIcon';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import TimelineStageElement from '../TimelineStageElement';
import Switch from "react-switch";
import ActiveStagePopUp from 'Components/ActivateStage/ActivateStagePopUp';
import { updateActiveStage } from '../../../../app/src/api/caseDataAPI';
import {getAllStageData} from './configStructure.js';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';

import Badge from 'Components/Badge/Badge';
import Circle from 'Components/icons/Circle';

import './TimelineAccordion.scss';

const TimelineAccordion = (props) => {
  const [isActiveStageToggled, setActiveStageToggled] = useState(false);
  const [isActivatBtnDisabled, setIsActivatBtnDisabled] = useState(false);
  const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  const isActiveStageIndicatorSettingsEnabled = useSelector((state) => state.appSearch.isActiveStageIndicatorSettingsEnabled);
  let openCase = {};
  if(!props.isMerchantUser){
    const openCases = useSelector((state) => state.caseInfo.openCases);
    openCase = openCases.filter((openCase) => openCase.caseDetail.caseNumber === parseInt(props.caseNumber))[0];
  }
  
  const getStageButtons = getAllStageData();

  let isActiveStagePresent = openCase?.activeCaseStageDetail !== null;

  const ShowLatestStage  = () => {
    return(
      <div className="time-header" style={{marginRight:7}}>
          <ClockIcon fill={'#262aff'} />
      </div>
    )
  }

  const TimeHeaderMerchant = () => {
    const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    return (
      <div className="time-header">
        <h4 className="vertical-timeline-element-subtitle aligned">
          <span className={"header-border "+acquirerCode}> </span>
          <ClockIcon fill= {acquirerCode=='HPY'?'#1362E2':`${props.fill}`} />
          <span className={"time "+acquirerCode}>{format(props.listItem.eventHeaderDetails.eventTimeStamp, `${props.dateFormat} ${props.timeFormat}`)}</span>
        </h4>
      </div>
    );
  };

  const TimeHeader = () => {
    let timeFormat = format(props.listItem.eventHeaderDetails.eventTimeStamp, `${props.dateFormat} ${props.timeFormat}`);
    timeFormat = timeFormat.substring(0, 3) + "." + timeFormat.substring(3, timeFormat.length);
    return (
      <div className="time-header">
        <h4 className="vertical-timeline-element-subtitle aligned">
          <span className='split-time'> </span>
          <span className={'time-case'+ acquirerCode} style={{ color: '#262aff'}}> Last Modified {timeFormat}</span>
        </h4>
      </div>
    );
  };

  const toggle = () => {
    props.toggleAccordion(props.listItem.caseStageId);
  };
  const ShowStatus = () => {
    const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    return (
      <div className={"timeline-status "+acquirerCode}>
     <span className={"header-border "+acquirerCode}></span>
     <span className={"splitter-status "+acquirerCode} >{props.listItem.disputeStageStatus}</span>
      </div>
    );
  };

  const ShowCaseStatus = () => {
    let badgeCss;
    if (isActiveStagePresent) {
      if (props.listItem.eventHeaderDetails.latestStageIndicator) {
         badgeCss =  'inactive-' + `${props.listItem.disputeStageStatus}`;
      } else if (props.listItem.eventHeaderDetails.activeStageIndicator) {
         badgeCss = 'active-' + `${props.listItem.disputeStageStatus}`;
      } else { 
        badgeCss = 'inactive-' + `${props.listItem.disputeStageStatus}`;
      }
    } else {
      if (props.listItem.eventHeaderDetails.latestStageIndicator) {
        badgeCss = 'active-' + `${props.listItem.disputeStageStatus}`;
      } else {
        badgeCss = 'inactive-' + `${props.listItem.disputeStageStatus}`;
      }
    }
    badgeCss = badgeCss.toLowerCase();
    return (
      <div className={'timeline-status ' + acquirerCode}>
        <span className="statusbadge">
          <Badge spanClass={badgeCss} caseStatus>
            {(badgeCss === 'active-closed' || badgeCss === 'active-open') && (
              <span className="circle-status">
                <Circle />
              </span>
            )}
            {props.listItem.disputeStageStatus}
          </Badge>
        </span>
      </div>
    );
  };
  
  const ShowTimeHeader = () => {
    return (
      <span className={'timeline-headers'}>
        {props.listItem.disputeStageName + ' '  + props.listItem.caseStageId}
      </span>
    );
  };

  const ShowTimeHeaderMerchant = () => {
    return (
      <span className={"splitter-stage-name splitter-stage-name__"+acquirerCode} > 
        {props.listItem.disputeStageName} 
      </span>
    );
  };

  const SlideOutButtons = () => {
    return (
      <div className="timeline-accordion-button">
        {!props.isMerchantUser && getStageButtons !== undefined && getStageButtons.map((value, index) => {
          return <button onClick={() => {openDrawer(value.buttonID)}} key={index} className="button-view-case-splitter">{value.buttonName}</button>
        })}

      </div>
    );
  };

  const onActiveStageIndicatorChange = (event) => {
    if (event && props.listItem.eventHeaderDetails.latestStageIndicator !== 1) {
      setActiveStageToggled(!isActiveStageToggled);
    } else if (
      (event && props.listItem.eventHeaderDetails.latestStageIndicator === 1) ||
      (!event && props.listItem.eventHeaderDetails.latestStageIndicator !== 1)
    ) {
      onActivateStageSubmit("");
    } else if (
      !event &&
      props.listItem.eventHeaderDetails.latestStageIndicator == 1
    ) {
      return false;
    } else {
      return false;
    }
  };  

  const onActivateStageSubmit = (comments) => {
    setIsActivatBtnDisabled(true);
    const payload = {
      currentActiveStageId: openCase.activeCaseStageDetail !== null ? openCase.activeCaseStageDetail?.caseStageId : null,
      latestStageId: openCase.caseStageDetail.caseStageId,
      newActiveStageId:  (comments || props.listItem.eventHeaderDetails.latestStageIndicator === 1) && (props.listItem.caseStageId !== openCase.caseStageDetail.responseToCaseStageId)? props.listItem.caseStageId : null,
      activationComment: comments,
      userId: JSON.parse(sessionStorage.getItem('state')).auth.user.userId
    };
    updateActiveStage(payload)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          setIsActivatBtnDisabled(false);
          toggleActivateStagePopup(false);
          props.setActiveStageIndicatorSettingsOpenFlag(false);
          props.getCaseDetails(props.caseNumber, true);
          props.getFetchCaseLoader();
        }
      })
      .catch((error) => {
        setIsActivatBtnDisabled(false);
        showActivatStageErrorBanner();
      });
  };
  

  const toggleActivateStagePopup = (flag) => {
    setActiveStageToggled(flag)
  }

  const getToggleChecked = () => {
    if (isActiveStagePresent) {
      if (props.listItem.eventHeaderDetails.activeStageIndicator === 1) {
        return true;
      } else {
        return false;
      }
    } else if (props.listItem.eventHeaderDetails.latestStageIndicator === 1) {
      return true;
    } else {
      return false;
    }
  };
  
  const ToggleButtons = () => {
    return (isActiveStageIndicatorSettingsEnabled &&
      props.listItem.eventHeaderDetails.disputeStageType === "I") ? (
      <div className="toggle-btn-div">
        {isActiveStageToggled && (
          <ActiveStagePopUp
            toggleActivateStagePopup={() => toggleActivateStagePopup()}
            isActivatBtnDisabled={isActivatBtnDisabled}
            onActivateStageSubmit={onActivateStageSubmit}
          />
        )}
        <Switch
          checked={getToggleChecked()}
          onChange={(event) => {
            onActiveStageIndicatorChange(event);
          }}
          onColor="#262aff"
          offColor="#595959"
          height={20}
          width={40}
          disabled={isActivatBtnDisabled}
        ></Switch>
      </div>
    ) : isActiveStageIndicatorSettingsEnabled && (
      <div className="hidden-div"></div>
    );
  };  
      
  const openDrawer = (id) => {
    props.getApiDrawerData(props.listItem.caseStageId, id);
    props.toggleDrawer(true,id);
  };

  const showActivatStageErrorBanner = () => {
    const notificationMessageError = {
      type: "error",
      placement: "topRight",
      messageWidth: 250,
      byDefault: true,
      duration: 5,
      content: (
        <div style={{ color: "black", paddingTop: 10 }}>
          <b>System Error</b>: Unable to activate the stage.
        </div>
      ),
    };
    openNotificationToast(notificationMessageError);
  };
  
  return (
    <div className="timeline-accordion">   
      <TimelineStageElement
        showLatestStage={!props.isMerchantUser && props.listItem.eventHeaderDetails.latestStageIndicator ? <ShowLatestStage /> : " "}
        headerText={!props.isMerchantUser ? <ShowTimeHeader /> : <ShowTimeHeaderMerchant />}
        isOpen={props.isOpen}
        toggleAccordion={() => toggle()}
        id={`${props.listItem.caseStageId}`}
        headerObjects={!props.isMerchantUser ? <TimeHeader fill={props.fill} /> : <TimeHeaderMerchant fill={props.fill} />}
        status = {!props.isMerchantUser ? <ShowCaseStatus /> : <ShowStatus />}
        slideOutButtons={<SlideOutButtons />}
        isMerchantUser = {props.isMerchantUser}
        toggleButtons={!props.isMerchantUser && <ToggleButtons />}
      />
    </div>
  );
};

TimelineAccordion.propTypes = {
  isOpen: PropTypes.bool,
  fill: PropTypes.string,
  listItem: PropTypes.object.isRequired,
  toggleAccordion: PropTypes.func,
  openDrawer: PropTypes.func
};

TimelineAccordion.defaultProps = {
  isOpen: true,
  fill: '',
  toggleAccordion: () => { },
  openDrawer: () => { }
};
export default TimelineAccordion;
